import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Button } from 'reactstrap';

const FilterResultBar = ({
  length = 0,
  handleResetFilter,
  type = 'Orders',
}) => {
  return (
    <div className="muiltiple-action-box d-inline-flex align-items-center ps-3 mt-2 mb-1">
      <span className="text-dark font-inter">
        Viewing <span className="fw-semibold">{length} Search Results </span> of
        all {type}{' '}
        <Button
          size="sm"
          className="small-btn"
          color="light"
          onClick={handleResetFilter}
        >
          <RxCross2 size={12} style={{ marginTop: '-2px' }} /> Clear Search
          Results
        </Button>
      </span>
    </div>
  );
};

export default FilterResultBar;
